import gql from 'graphql-tag'

export const GET_GEO_LOCATION = gql`
  query GetGeolocation($ip: String) {
    getLocationByIp(ip: $ip) {
      ip
      countryCode
      countryName
    }
  }
`
